// // components/ui/Select.jsx - Shadcn style Select
// import React, { useState } from "react";





// const Select = React.forwardRef(({
//   className,
//   options = [],
//   value,
//   defaultValue,
//   placeholder = "Select an option",
//   multiple = false,
//   disabled = false,
//   required = false,
//   label,
//   description,
//   error,
//   searchable = false,
//   clearable = false,
//   loading = false,
//   id,
//   name,
//   onChange,
//   onOpenChange,
//   ...props
// }, ref) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   // Generate unique ID if not provided
//   const selectId = id || `select-${Math.random()?.toString(36)?.substr(2, 9)}`;

//   // Filter options based on search
//   const filteredOptions = searchable && searchTerm ?
//   options?.filter((option) =>
//   option?.label?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
//   option?.value && option?.value?.toString()?.toLowerCase()?.includes(searchTerm?.toLowerCase())
//   ) :
//   options;

//   // Get selected option(s) for display
//   const getSelectedDisplay = () => {
//     if (!value) return placeholder;

//     if (multiple) {
//       const selectedOptions = options?.filter((opt) => value?.includes(opt?.value));
//       if (selectedOptions?.length === 0) return placeholder;
//       if (selectedOptions?.length === 1) return selectedOptions?.[0]?.label;
//       return `${selectedOptions?.length} items selected`;
//     }

//     const selectedOption = options?.find((opt) => opt?.value === value);
//     return selectedOption ? selectedOption?.label : placeholder;
//   };

//   const handleToggle = () => {
//     if (!disabled) {
//       const newIsOpen = !isOpen;
//       setIsOpen(newIsOpen);
//       onOpenChange?.(newIsOpen);
//       if (!newIsOpen) {
//         setSearchTerm("");
//       }
//     }
//   };

//   const handleOptionSelect = (option) => {
//     if (multiple) {
//       const newValue = value || [];
//       const updatedValue = newValue?.includes(option?.value) ?
//       newValue?.filter((v) => v !== option?.value) :
//       [...newValue, option?.value];
//       onChange?.(updatedValue);
//     } else {
//       onChange?.(option?.value);
//       setIsOpen(false);
//       onOpenChange?.(false);
//     }
//   };

//   const handleClear = (e) => {
//     e?.stopPropagation();
//     onChange?.(multiple ? [] : '');
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e?.target?.value);
//   };

//   const isSelected = (optionValue) => {
//     if (multiple) {
//       return value?.includes(optionValue) || false;
//     }
//     return value === optionValue;
//   };

//   const hasValue = multiple ? value?.length > 0 : value !== undefined && value !== '';

//   return;





































































































































// });

// Select.displayName = "Select";

// export default Select;

import React, { useState } from "react";

const Select = React.forwardRef(({
  className,
  options = [],
  value,
  placeholder = "Select an option",
  multiple = false,
  disabled = false,
  searchable = false,
  clearable = false,
  loading = false,
  onChange,
  onOpenChange,
}, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredOptions =
    searchable && searchTerm
      ? options.filter(
          (option) =>
            option.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
            option.value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      : options;

  const getSelectedDisplay = () => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return placeholder;
    }

    if (multiple) {
      const selected = options.filter(opt => value.includes(opt.value));
      if (selected.length === 1) return selected[0].label;
      return `${selected.length} items selected`;
    }

    const selected = options.find(opt => opt.value === value);
    return selected?.label || placeholder;
  };

  const toggleOpen = () => {
    if (disabled) return;
    const next = !isOpen;
    setIsOpen(next);
    onOpenChange?.(next);
    if (!next) setSearchTerm("");
  };

  const handleSelect = (option) => {
    if (multiple) {
      const nextValue = value?.includes(option.value)
        ? value.filter(v => v !== option.value)
        : [...(value || []), option.value];
      onChange?.(nextValue);
    } else {
      onChange?.(option.value);
      setIsOpen(false);
      onOpenChange?.(false);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange?.(multiple ? [] : "");
  };

  return (
    <div className="relative w-full">
      {/* Trigger */}
      <button
        type="button"
        ref={ref}
        onClick={toggleOpen}
        disabled={disabled}
        className="w-full flex items-center justify-between px-3 py-2 text-sm border border-border rounded-md bg-background"
      >
        <span className="truncate">{getSelectedDisplay()}</span>
        {clearable && value && (
          <span onClick={handleClear} className="ml-2 text-muted-foreground">×</span>
        )}
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-50 mt-1 w-full bg-card border border-border rounded-md shadow-lg max-h-60 overflow-auto">
          {searchable && (
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search..."
              className="w-full px-2 py-1 text-sm border-b border-border outline-none"
            />
          )}

          {filteredOptions.length === 0 && (
            <div className="px-3 py-2 text-sm text-muted-foreground">
              No options
            </div>
          )}

          {filteredOptions.map(option => (
            <div
              key={option.value}
              onClick={() => handleSelect(option)}
              className={`px-3 py-2 text-sm cursor-pointer hover:bg-muted ${
                multiple && value?.includes(option.value)
                  ? "bg-muted"
                  : !multiple && value === option.value
                  ? "bg-muted"
                  : ""
              }`}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

Select.displayName = "Select";

export default Select;
